<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <modal :name="modalName" width="800px" :clickToClose="false" height="940px" @before-open="beforeOpen" @before-close="beforeClose">
        <ModalDriverSelector></ModalDriverSelector>
        <ModalPassengerSelector></ModalPassengerSelector>
        <v-card>
            <v-card-title>
                <span class="headline">APP PUSH</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-0" style="width: 800px; height: 820px;">
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12 class="pa-0" v-if="id">
                            <v-text-field
                                    label="고유번호"
                                    v-model="item.id"
                                    disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 class="pa-0">
                            <v-select
                                    :items="pushMessageAction"
                                    v-model="item.action"
                                    label="타입"
                                    item-text="text"
                                    item-value="state"
                                    :disabled="item.deleted || (item.state && item.state !== 'REQUEST')"
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 class="pa-0">
                            <v-radio-group v-model="item.userType" label="대상: " row>
                                <v-radio
                                        v-for="(userType, i) in userTypes"
                                        :key="i"
                                        :value="userType.value"
                                        :label="userType.text"
                                        :disabled="id ? true : false"
                                ></v-radio>
                            </v-radio-group>
                        </v-flex>
                        <v-flex xs12 class="pa-0" v-if="item.userType">
                            <v-radio-group v-model="item.range" label="범위: " row>
                                <v-radio
                                        v-for="(range, i) in ranges"
                                        :key="i"
                                        :value="range.value"
                                        :label="range.text"
                                        :disabled="id ? true : false"
                                ></v-radio>
                            </v-radio-group>
                        </v-flex>
                        <v-flex xs12 class="pa-0" v-show="item.range && item.range === 'TARGET_BY_SELECT'">
                            <v-btn small color="primary" @click="searchUsers" :disabled="id ? true : false">검색</v-btn>
                            선택된 유저: {{selectedIds.length}}명
                        </v-flex>
                        <v-flex xs12 class="pa-0" v-show="item.range && item.range === 'TARGET_BY_UPLOAD'">
                            <input type="file" ref="file" v-if="!id" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="handleFileUpload">

                            <template v-if="id">선택된 유저: {{selectedIds.length}}명</template>
                        </v-flex>
                        <v-flex xs12 class="pa-0">
                            <v-text-field
                                    label="제목"
                                    v-model="item.title"
                                    :disabled="item.deleted || (item.state && item.state !== 'REQUEST')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 class="pa-0">
                            <v-text-field
                                    label="내용"
                                    v-model="item.body"
                                    :disabled="item.deleted || (item.state && item.state !== 'REQUEST')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 class="pa-0" v-if="item.action && item.action !== 'NONE' && item.action !== 'APP_UPDATE'">
                            <v-text-field
                                    label="데이터"
                                    v-model="item.param"
                                    :disabled="item.deleted || (item.state && item.state !== 'REQUEST')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm3 class="pa-0">
                            <v-checkbox v-model="item.useReservation" label="예약 발송" :disabled="item.deleted || item.state && item.state !== 'REQUEST'"></v-checkbox>
                        </v-flex>
                        <v-flex sm3 class="pa-0" v-if="item.useReservation">
                            <v-menu
                                    class="pa-1"
                                    ref="datePicker"
                                    lazy
                                    :close-on-content-click="false"
                                    v-model="datePicker.menu"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    :nudge-bottom="-22"
                                    max-width="290px"
                                    :return-value.sync="datePicker.value"
                            >
                                <v-text-field
                                        slot="activator"
                                        label="일자"
                                        v-model="datePicker.value"
                                        append-icon="event"
                                        readonly
                                        :disabled="item.deleted || (item.state && item.state !== 'REQUEST')"
                                ></v-text-field>
                                <v-date-picker v-model="datePicker.value" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="datePicker.menu = false">Cancel</v-btn>
                                    <v-btn flat color="primary" @click="$refs.datePicker.save(datePicker.value)">OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex sm3 class="pa-1" v-if="item.useReservation">
                            <v-dialog
                                    ref="dialog2"
                                    v-model="timePicker.visible"
                                    :return-value.sync="timePicker.value"
                                    persistent
                                    lazy
                                    full-width
                                    width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            v-model="timePicker.value"
                                            label="시간"
                                            prepend-icon="access_time"
                                            readonly
                                            v-on="on"
                                            :disabled="item.deleted || (item.state && item.state !== 'REQUEST')"
                                    ></v-text-field>
                                </template>
                                <v-time-picker
                                        v-if="timePicker.visible"
                                        v-model="timePicker.value"
                                        full-width
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="timePicker.visible = false">Cancel</v-btn>
                                    <v-btn flat color="primary" @click="$refs.dialog2.save(timePicker.value)">OK</v-btn>
                                </v-time-picker>
                            </v-dialog>
                        </v-flex>
                        <v-flex xs12 class="pa-0" v-if="id">
                            <v-text-field
                                    label="등록시간"
                                    v-model="item.regDate"
                                    disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 class="pa-0" v-if="id">
                            <v-btn small color="red" @click="deletePushMessage" :disabled="item.deleted || (item.state && item.state !== 'REQUEST')">삭제</v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer>
                </v-spacer>
                <v-btn color="blue darken-1" flat @click="save" v-show="!id || (!item.deleted && item.state === 'REQUEST')">저장</v-btn>
                <v-btn color="blue darken-1" flat @click="closeModal">닫기</v-btn>
            </v-card-actions>
        </v-card>
    </modal>
</template>

<script>
    import PushMessageAction from '@/api/pushMessageAction';
    import ModalDriverSelector from '../modal-driver-selector';
    import ModalPassengerSelector from '../modal-passenger-selector';

    export default {
        components: {ModalDriverSelector, ModalPassengerSelector},
        data : function() {
            return {
                id: null,
                item: {},
                selectedIds: [],
                timePicker: {
                    visible: false,
                    value: null
                },
                datePicker: {
                    menu: false,
                    value: null
                },
                file: null,
                userTypes: [
                    {text: '승객', value: 'P'},
                    {text: '기사', value: 'D'}
                ],
                ranges: [
                    {text: '전체', value: 'ALL'},
                    {text: '사용자 지정', value: 'TARGET_BY_SELECT'},
                    {text: '사용자 지정 (업로드)', value: 'TARGET_BY_UPLOAD'}
                ],
                pushMessageAction: PushMessageAction
            }
        },
        props : {
            modalName: {
                required: false,
                default: 'modal-app-push',
            }
        },
        watch : {
            'item.userType'() {
                this.selectedIds = [];
            }
        },
        mounted () {

        },
        methods: {
            beforeOpen (e) {
                this.id = e.params.id;

                if(this.id) {
                    this.getPushMessage();
                    this.getPushMessageTargets();
                }
                if(e.params.callback) {
                    this.callback = e.params.callback;
                }
            },
            beforeClose () {
                this.clearModalData();
            },
            clearModalData() {
                this.id = null;
                this.item = {};
                this.selectedIds = [];
                this.timePicker = {visible: false, value: null};
                this.datePicker = {menu: false, value: null};
                this.file = null;
            },
            closeModal () {
                this.beforeClose();
                this.$modal.hide(this.modalName);
            },
            getPushMessage () {
                const parameter = {
                    method: 'searchPushMessageDetail',
                    id: this.id
                };

                this.$store.dispatch('banbanAPI', parameter)
                    .then(({ data }) => {
                        top.getApp.progress.dialog = false;

                        this.initData(data);
                    })
                    .catch((error) => {
                        if (top.getApp.commonError == null) {
                            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                        }
                        top.getApp.commonError = null;
                        top.getApp.progress.dialog = false;
                    });
            },
            getPushMessageTargets () {
                const parameter = {
                    method: 'searchPushMessageTargets',
                    id: this.id
                };

                this.$store.dispatch('banbanAPI', parameter)
                    .then(({ data }) => {
                        top.getApp.progress.dialog = false;

                        let ids = [];
                        data.forEach(item => {
                            ids.push(item.id);
                        });

                        this.selectedIds = ids;
                    })
                    .catch((error) => {
                        if (top.getApp.commonError == null) {
                            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                        }
                        top.getApp.commonError = null;
                        top.getApp.progress.dialog = false;
                    });
            },
            initData(pushMessage) {
                this.item = {
                    id: pushMessage.id,
                    action: pushMessage.action,
                    userType: pushMessage.userType,
                    range: pushMessage.range,
                    title: pushMessage.title,
                    body: pushMessage.body,
                    param: pushMessage.param,
                    state: pushMessage.state,
                    regDate: pushMessage.regDate,
                    deleted: pushMessage.deleted
                };

                if(pushMessage.reservationDate) {
                    this.item.useReservation = true;
                    this.datePicker.value = pushMessage.reservationDate.split(' ')[0];
                    this.timePicker.value = pushMessage.reservationDate.split(' ')[1];
                }
            },
            save () {
                if(!this.validate()) return;
                if(!confirm('푸시메세지를 저장하시겠습니까?')) return;

                if(this.id) {
                    this.item.method = 'editPushMessages';
                } else {
                    this.item.method = 'createPushMessages';
                }

                if(this.item.useReservation) {
                    this.item.reservationDate = moment(this.datePicker.value + ' ' + this.timePicker.value).format('YYYY.MM.DD HH:mm:ss');
                } else {
                    this.item.reservationDate = null;
                }

                if(this.item.action === 'NONE' || this.item.action === 'APP_UPDATE') {
                    this.item.param = null;
                }

                if(this.item.range === 'TARGET_BY_SELECT') {
                    this.item.userIds = this.selectedIds;
                }

                if(this.item.range === 'TARGET_BY_UPLOAD') {
                    this.item.file = this.file;
                }

                if(this.id) {
                    this.updatePushMessage();
                } else {
                    this.savePushMessage();
                }
            },
            savePushMessage () {
                const formData = this.convertItemToFormData();

                top.getApp.progress.dialog = true;
                this.$http.post(window.apiHost.adminApiHost + '/pushMessages', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(({ data }) => {
                    top.getApp.progress.dialog = false;

                    if(data.errorCode) {
                        alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                        return;
                    }

                    alert('저장이 완료되었습니다.');
                    this.closeModal();
                    this.callback();
                }).catch((res) => {
                    alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');

                    top.getApp.progress.dialog = false;
                });
            },
            updatePushMessage () {
                this.$store.dispatch('banbanAPI', this.item)
                    .then(({ data }) => {
                        top.getApp.progress.dialog = false;

                        if(data.errorCode) {
                            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                            return;
                        }

                        alert('저장이 완료되었습니다.');
                        this.closeModal();
                        this.callback();
                    })
                    .catch((error) => {
                        if (top.getApp.commonError == null) {
                            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                        }
                        top.getApp.commonError = null;
                        top.getApp.progress.dialog = false;
                    });
            },
            convertItemToFormData() {
                const formData = new FormData();
                formData.append("action", this.item.action);
                formData.append("userType", this.item.userType);
                formData.append("range", this.item.range);
                formData.append("title", this.item.title);
                formData.append("body", this.item.body);

                if(this.item.userIds) {
                    formData.append("userIds", this.item.userIds);
                }

                if(this.item.param) {
                    formData.append("param", this.item.param);
                }

                if(this.item.file) {
                    formData.append("file", this.item.file);
                }

                if(this.item.reservationDate) {
                    formData.append("reservationDate", this.item.reservationDate);
                }

                return formData;
            },
            validate () {
                if(!this.item.action) {
                    alert('타입을 선택해 주세요.');
                    return false;
                }
                if(!this.item.userType) {
                    alert('대상을 선택해 주세요.');
                    return false;
                }
                if(!this.item.range) {
                    alert('범위를 선택해 주세요.');
                    return false;
                }
                if(this.item.range === 'TARGET_BY_SELECT' && this.selectedIds.length === 0) {
                    alert('유저를 선택해 주세요.');
                    return false;
                }
                if(this.item.range === 'TARGET_BY_UPLOAD' && this.file === null) {
                    alert('파일을 선택해 주세요.');
                    return false;
                }
                if(!this.item.title) {
                    alert('제목을 입력해 주세요.');
                    return false;
                }
                if(this.item.action !== 'NONE' && this.item.action !== 'APP_UPDATE' && !this.item.param) {
                    alert('데이터를 입력해 주세요.');
                    return false;
                }
                if(!this.item.body) {
                    alert('내용을 입력해 주세요.');
                    return false;
                }
                if(this.item.useReservation && (!this.datePicker.value || !this.timePicker.value)) {
                    alert('예약시간을 정확하게 입력해 주세요.');
                    return false;
                }
                return true;
            },
            searchUsers() {
                if(this.item.userType === 'P') {
                    this.$modal.show('modal-passenger-selector', {callback: this.applyUser});
                } else {
                    this.$modal.show('modal-driver-selector', {callback: this.applyUser});
                }
            },
            applyUser(ids) {
                this.selectedIds = ids;
            },
            deletePushMessage () {
                if(!confirm('정말 삭제하시겠습니까?')) return;
                const prameters = {
                    method: 'deletePushMessage',
                    id: this.id,
                };
                this.$store.dispatch('banbanAPI', prameters)
                    .then(({ data }) => {
                        alert('삭제되었습니다.');
                        top.getApp.progress.dialog = false;

                        this.closeModal();
                        this.callback();
                    })
                    .catch((error) => {
                        if (top.getApp.commonError == null) {
                            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                        }
                        top.getApp.commonError = null;
                        top.getApp.progress.dialog = false;
                    });
            },
            handleFileUpload () {
                this.file = this.$refs.file.files[0];
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/modal/appPush/modal-app-push-detail.vue